var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header-wrapper",style:(_vm.bgClass)},[_c('div',{staticClass:"header"},[_c('yj-nav-logo'),_c('div',{staticClass:"order-progress"},[_vm._t("contentSlot")],2)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }